import { IconsProps } from '@/types/shared'
import React from 'react'

const SettingsRemoteIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
            >
                <path
                    d="M15.0046 9.5H9.00461C8.45461 9.5 8.00461 9.95 8.00461 10.5V22.5C8.00461 23.05 8.45461 23.5 9.00461 23.5H15.0046C15.5546 23.5 16.0046 23.05 16.0046 22.5V10.5C16.0046 9.95 15.5546 9.5 15.0046 9.5ZM14.0046 21.5H10.0046V11.5H14.0046V21.5Z"
                    fill="currentColor"
                />
                <path
                    d="M12.0046 14.5C12.5569 14.5 13.0046 14.0523 13.0046 13.5C13.0046 12.9477 12.5569 12.5 12.0046 12.5C11.4523 12.5 11.0046 12.9477 11.0046 13.5C11.0046 14.0523 11.4523 14.5 12.0046 14.5Z"
                    fill="currentColor"
                />
                <path
                    d="M7.05461 6.55L8.46461 7.96C9.37461 7.06 10.6246 6.5 12.0046 6.5C13.3846 6.5 14.6346 7.06 15.5446 7.96L16.9546 6.55C15.6846 5.28 13.9346 4.5 12.0046 4.5C10.0746 4.5 8.32461 5.28 7.05461 6.55ZM12.0046 0.5C8.96461 0.5 6.21461 1.73 4.22461 3.72L5.63461 5.13C7.26461 3.51 9.51461 2.5 12.0046 2.5C14.4946 2.5 16.7446 3.51 18.3646 5.14L19.7746 3.73C17.7946 1.73 15.0446 0.5 12.0046 0.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default SettingsRemoteIcons
